// extracted by mini-css-extract-plugin
export var closeButton = "ContactForm-module--closeButton--5f940";
export var root = "ContactForm-module--root--88399";